import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import { VueAuthenticate } from 'vue-authenticate';
import forEach from 'lodash/forEach';
import { Model } from 'vue-api-query';
import store from '@state/store';
import router from '@router';

Axios.defaults.baseURL = '/api';
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
  (response) => {
    if (response.data.message) {
      Vue.toasted.success(response.data.message);
    }
    store.dispatch('wait/end', 'global loading', { root: true });
    return response;
  },
  async (error) => {
    if (error.response.status === 422) {
      if(error.response.data.message) {
        Vue.toasted.error(error.response.data.message);
      } else if(error.response.data.errors === undefined || error.response.data.errors === null) {
        Vue.toasted.error('Unknown validation error');
      } else {
        forEach(error.response.data.errors, (err) => {
          Vue.toasted.error(err[0]);
        });
      }
    } else {
      if (error.response.data.message) {
        Vue.toasted.error(error.response.data.message);
      } else if(error.response.message !== undefined && error.response.message !== null) {
        Vue.toasted.error(error.response.message);
      } else {
        // maybe it's error with blobs, so we will extract message like this
        const responseError = JSON.parse(await error.response.data.text());

        if(responseError !== undefined && responseError !== null
          && responseError.message !== undefined && responseError.message !== null) {
          Vue.toasted.error(responseError.message);
        } else {
          Vue.toasted.error('Not Found');
        }
      }
    }
    if (error.response.status === 401) {
      store.dispatch('auth/logout', {
        loggedOut: true,
        router: router,
      });
    }
    store.dispatch('wait/end', 'global loading', { root: true });

    return Promise.reject(error);
  }
);

// Bind Axios to Vue.
Model.$http = Axios;

Vue.use(VueAxios, Axios);

Vue.$auth = new VueAuthenticate(Vue.prototype.$http, {
  // baseUrl: '/api',
  loginUrl: '/auth/login/admin',
});
